<script setup lang="ts">
import { useToast } from '@/composables/useToast';

/**
 * Mini-toast inline (ancré dans le panel itinéraire).
 * Le composable expose `toast` (ref réactif) et `show()`.
 * On consomme uniquement `toast` ici — `show()` est appelé partout dans l'app.
 */
const { toast } = useToast();

const iconMap = {
  success: 'ti-check',
  error: 'ti-alert-circle',
  info: 'ti-info-circle',
} as const;
</script>

<template>
  <Transition
    enter-active-class="transition-all duration-200"
    leave-active-class="transition-all duration-200"
    enter-from-class="opacity-0 translate-y-2"
    leave-to-class="opacity-0 translate-y-2"
  >
    <div
      v-if="toast.visible"
      :class="[
        'flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium mt-3',
        toast.type === 'error'
          ? 'bg-red-50 text-red-700 border border-red-200'
          : toast.type === 'info'
            ? 'bg-blue-50 text-blue-700 border border-blue-200'
            : 'bg-green-50 text-green-700 border border-green-200',
      ]"
      role="status"
      aria-live="polite"
    >
      <i :class="['ti', iconMap[toast.type]]" aria-hidden="true"></i>
      <span>{{ toast.msg }}</span>
    </div>
  </Transition>
</template>
